import type {AxiosPromise} from 'axios';

import {CUSTOMER, PROFILE} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

import type {CustomerType} from './customerType';

export const initialState = {
    currency: {
        symbol: '$',
        code: 'USD',
    },
    is_logged_in: false,
    firstname: '',
    lastname: '',
    form_key: '',
    subscriber_id: '',
    subscription_date: '',
    simple_subscription_date: '',
    login_in_status: '',
    login_method: '',
    sid: '',
    is_coupon_applied: '',
    is_subscribed: '',
    email: '',
    md5: '',
    sha1: '',
    sha256: '',
    coupon_code: '',
    previous_category_id: '',
    previous_category_name: '',
    status: 'pending',
};

/**
 * Control customer information
 * @param {CustomerType} state - Current customer state
 * @param {ActionType<AxiosPromise>} action - Received action
 * @returns {CustomerType} - Next customer state
 */
export default function customer(
    state: CustomerType = initialState,
    action: ActionType<AxiosPromise>,
): CustomerType {
    switch (action.type) {
        case `${CUSTOMER.GET_CUSTOMER_DATA}_FULFILLED`:
            return {
                ...state,
                ...action.payload.data,
                status: 'fulfilled',
            };
        case PROFILE.SET_CUSTOMER_SUBSCRIBED:
            return {...state, is_subscribed: action.payload};
        default:
            return state;
    }
}
